import { render, staticRenderFns } from "./visitinfo.vue?vue&type=template&id=f84ce39e"
import script from "./visitinfo.vue?vue&type=script&lang=js"
export * from "./visitinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports